export const API_KEY = "f5fd0f62-df0e-11f0-a99e-066a7fa2e369";
export const API_URL = "https://api.liveavatar.com";
export const AVATAR_ID = "305d6280-7893-4c7f-9cc4-e742135ecb05";

// FULL MODE Customizations
// Wayne's avatar voice and context
export const VOICE_ID = "62bbb4b2-bb26-4727-bc87-cfb2bd4e0cc8";
export const CONTEXT_ID = "16796ec6-d6b7-4886-83a7-b586cfffd00a";
export const LANGUAGE = "hi";

// CUSTOM MODE Customizations
export const ELEVENLABS_API_KEY = "YOUR_ELEVENLABS_API_KEY";
export const OPENAI_API_KEY = "AIzaSyCs3WHe_SVM3ruEfKVuQ7A0pvExJqfNXeA";
